var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000120561149607042652890000017966883264227359376_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7,47.6c-2.4,0.1-4.8-0.3-7-1.2c-11.2-4.6-19-12.5-23.3-23.8c-1.2-2.8-1.4-6-0.6-9c0.9-2.9,3-4.8,5.3-6.5 c1.8-1.2,4.3-1,5.8,0.6c1.5,1.5,3.1,3,4.6,4.6c1.8,1.8,1.8,4.8,0,6.6c-0.6,0.6-1.1,1.2-1.7,1.7c-0.4,0.3-0.5,0.8-0.2,1.2 c0,0,0.1,0.1,0.1,0.1c3.1,4.5,7,8.4,11.6,11.5c0.3,0.3,0.8,0.3,1.1,0c0,0,0.1-0.1,0.1-0.1c0.6-0.6,1.1-1.2,1.7-1.7 c1.8-1.9,4.8-1.9,6.7,0c0,0,0,0,0,0c1.6,1.5,3.1,3,4.6,4.6c1.6,1.6,1.8,4,0.5,5.9c-1.3,1.9-3,3.4-5,4.5 C34.6,47.3,33.2,47.7,31.7,47.6z M3.7,17.1c0,0.7,0.1,1.3,0.3,2c0.2,1.1,0.5,2.2,0.9,3.2c3.7,9,10.7,16.3,19.6,20.3 c2.1,0.9,4.3,1.5,6.5,1.6c2.4,0.2,6-1.9,7.1-4.1c0.3-0.6,0.2-1.4-0.4-1.8c-1.4-1.3-2.8-2.7-4.1-4.1c-0.9-0.8-1.6-0.8-2.5,0 c-0.9,0.8-1.7,1.7-2.5,2.5c-1.1,1.1-1.6,1.2-2.9,0.4c-6.1-3.7-11.2-8.8-14.9-14.9c-0.7-0.7-0.6-1.9,0.2-2.5c0,0,0.1-0.1,0.1-0.1 c0.9-0.9,1.8-1.8,2.7-2.7c0.7-0.5,0.8-1.5,0.3-2.2c-0.1-0.1-0.2-0.2-0.3-0.3c-1.4-1.4-2.8-2.8-4.1-4.2C9.2,9.7,8.3,9.5,7.6,10 c-0.1,0.1-0.2,0.2-0.3,0.2c-0.6,0.5-1.1,1-1.6,1.6C4.4,13.2,3.6,15.2,3.7,17.1L3.7,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7,23v1c0.1,0.9-0.6,1.7-1.5,1.8c-0.9,0.1-1.7-0.6-1.8-1.5c0-0.1,0-0.2,0-0.2c-0.1-1.9-0.3-3.7-0.8-5.5 c-2.3-8.3-9.5-14.2-18.1-14.8c-0.5,0-1-0.1-1.6-0.1c-0.9,0-1.6-0.7-1.6-1.6c0,0,0,0,0,0c0-0.9,0.7-1.6,1.5-1.7c0.1,0,0.1,0,0.2,0 c3.3-0.1,6.5,0.6,9.4,2c8.2,3.8,12.8,10.2,14.1,19.1c0,0.1,0,0.3,0,0.4L47.7,23L47.7,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9,22.5c0,1.4-0.7,2.2-1.7,2.3s-1.7-0.8-1.8-2c-0.1-5-4.1-9-9.1-9.2c-1,0-1.8-0.7-1.9-1.7c0.1-1,0.9-1.8,1.9-1.7 c0,0,0,0,0.1,0c6.1,0.2,11.2,4.7,12.2,10.7C37.8,21.5,37.8,22.1,37.9,22.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneno);
export default __webpack_public_path__ + "static/media/phone no..a64c0812a4224638765818ea41eb238d.svg";
export { ForwardRef as ReactComponent };